<div class="container greyTextContainer">
  <h1>Contact</h1>
  <div class="textContainer">
    <div class="side-text">
      <p>
        We'd love to hear from you. <br />
        Feel free to contact us at:
      </p>

      <div class="details">
        <p>
          Phone: <br />
          0407 838 657
        </p>
        <p>
          Enquiries: <br />
          <a href="mailto:info@adiem.com.au?subject=Enquiry:"
            >info&#64;adiem.com.au</a
          >
        </p>
        <p>
          Send your invoices to: <br />
          <a href="mailto:info@adiem.com.au?subject=Enquiry:"
            >invoices&#64;adiem.com.au</a
          >
        </p>
      </div>
    </div>

    <img
      src="../../assets/img/smiling-girl-in-wheelchair.png"
      alt="Young girl in a wheelchair"
    />
  </div>

  <hr />

  <form [formGroup]="contactForm">
    <!-- FIRST NAME -->
    <mat-form-field appearance="fill">
      <mat-label>First Name</mat-label>
      <input
        #nameFirst
        type="text"
        formControlName="nameFirst"
        required
        matInput
        placeholder="Enter your first name"
      />
      <mat-error *ngIf="f.nameFirst.touched && f.nameFirst.errors">
        <mat-error *ngIf="f.nameFirst.errors.required">
          First name is required
        </mat-error>
        <mat-error *ngIf="f.nameFirst.errors.notAllLetters">
          First name must be letters, spaces and hyphens only
        </mat-error>
      </mat-error>
    </mat-form-field>

    <!-- LAST NAME -->
    <mat-form-field appearance="fill">
      <mat-label>Last Name</mat-label>
      <input
        #nameLast
        type="text"
        formControlName="nameLast"
        required
        matInput
        placeholder="Enter your last name"
      />
      <mat-error *ngIf="f.nameLast.touched && f.nameLast.errors">
        <mat-error *ngIf="f.nameLast.errors.required">
          Last name is required
        </mat-error>
        <mat-error *ngIf="f.nameLast.errors.notAllLetters">
          Last name must be letters, spaces and hyphens only
        </mat-error>
      </mat-error>
    </mat-form-field>

    <!-- MOBILE -->
    <mat-form-field appearance="fill">
      <mat-label>Phone</mat-label>
      <input
        #mobile
        type="tel"
        formControlName="mobile"
        required
        matInput
        placeholder="Enter your mobile number"
      />
      <mat-error *ngIf="f.mobile.touched && f.mobile.errors">
        <mat-error *ngIf="f.mobile.errors.required">
          Phone is required
        </mat-error>
        <mat-error *ngIf="f.mobile.errors.wrongFormat">
          Phone must be numbers only in Australian format
        </mat-error>
        <mat-error *ngIf="f.mobile.errors.min"> Not enough numbers </mat-error>
        <mat-error *ngIf="f.mobile.errors.max"> Too many numbers </mat-error>
      </mat-error>
    </mat-form-field>

    <!-- EMAIL -->
    <mat-form-field appearance="fill">
      <mat-label>Email</mat-label>
      <input
        #email
        type="email"
        formControlName="email"
        required
        matInput
        placeholder="Enter your email address"
      />
      <mat-error *ngIf="f.email.touched && f.email.errors">
        <mat-error *ngIf="f.email.errors.required">
          Email is required
        </mat-error>
        <mat-error *ngIf="f.email.errors && !f.email.errors.required">
          Email isn't in the correct format
        </mat-error>
      </mat-error>
    </mat-form-field>

    <!-- MESSAGE -->
    <mat-form-field appearance="fill">
      <mat-label>Message</mat-label>
      <textarea
        #message
        matInput
        type="textarea"
        formControlName="message"
        required
        placeholder="Your message..."
      ></textarea>
      <mat-error *ngIf="f.message.touched && f.message.errors">
        <mat-error *ngIf="f.message.errors.required">
          A message is required
        </mat-error>
        <mat-error *ngIf="f.message.errors.notAllowed">
          Only letters, numbers and basic punctuation allow
        </mat-error>
      </mat-error>
    </mat-form-field>

    <div class="centreButton">
      <button
        class="submitBtn"
        [class.formInvalidBtn]="contactForm.invalid"
        mat-raised-button
        type="button"
        color="primary"
        (click)="submitForm()"
      >
        <span [class.formInvalidBtn]="contactForm.invalid" *ngIf="!submitted"
          >Enquire</span
        >
        <!-- Animated Circle Submission Confirmation -->
        <div
          [ngClass]="{ 'circle-loader': submitted, 'load-complete': delivered }"
        >
          <div
            class="checkmark draw"
            [ngStyle]="{ display: delivered ? 'block' : 'none' }"
          ></div>
        </div>
      </button>
    </div>

    <br />
  </form>
</div>
